export default __webpack_public_path__ + "static/media/tyler.111056c1.jpeg";